import { useTranslation } from 'react-i18next';

import { Link } from '@remix-run/react';

import LoginWithPasswordAction from '~/components/Actions/LoginWithPasswordAction';
import SubscribeLoginSlideUpModal from '~/components/Modal/SubscribeLoginSlideUpModal';
import Text from '~/components/Text';
import type { Publication } from '~/interfaces/publication';

interface Props {
  isOpen: boolean;
  handleCloseModal: () => void;
  publication: Publication;
}

const LoginModal = ({ isOpen, handleCloseModal, publication }: Props) => {
  const { t } = useTranslation();

  const showLoginWithPassword = !!publication?.has_subscription_password;

  return (
    <SubscribeLoginSlideUpModal
      title={t('shared.cta.login_to_pub', { name: publication.name })}
      description={`${t('nav.description')}`}
      isOpen={isOpen}
      onClose={handleCloseModal}
      publication={publication}
      alternativeAction={
        !publication.private ? (
          <div className="flex flex-col">
            <Text as="p" size="xs" type="body" theme={'default'}>
              {t('login.sign_up_label')}{' '}
              <Link to="/subscribe" className="underline">
                <Text as="span" size="xs" type="body" weight="bold" theme={'default'}>
                  {t('shared.cta.sign_up')}
                </Text>
              </Link>
            </Text>
          </div>
        ) : (
          ''
        )
      }
    >
      <LoginWithPasswordAction
        onSuccess={handleCloseModal}
        bypassSparkLoopMode
        showLoginWithPassword={showLoginWithPassword}
      />
    </SubscribeLoginSlideUpModal>
  );
};

export default LoginModal;
